module.exports = __webpack_public_path__ + "img/product-placeholder-40.2005ffd.png";